type TokenGetter = () => Promise<string>;

let auth0TokenGetter: TokenGetter | null = null;

const AUTH0_LOCAL_STORAGE_PREFIX = '@@auth0spajs@@';
const AUTH0_TRANSACTION_PREFIX = 'a0.spajs.txs';

const clearAuth0Cache = () => {
  [localStorage, sessionStorage].forEach((storage) => {
    Object.keys(storage).forEach((key) => {
      if (key.startsWith(AUTH0_LOCAL_STORAGE_PREFIX) || key.startsWith(AUTH0_TRANSACTION_PREFIX)) {
        storage.removeItem(key);
      }
    });
  });
};

const clearAuth0Cookies = () => {
  if (typeof document === 'undefined') return;

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=', 1)[0]?.trim();
    if (name?.startsWith('auth0.')) {
      document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    }
  });
};

export const setAuth0TokenGetter = (getter: TokenGetter) => {
  auth0TokenGetter = getter;
};

export const getAuth0Token = async (): Promise<string | null> => {
  if (auth0TokenGetter) {
    try {
      return await auth0TokenGetter();
    } catch (error) {
      clearTokenInfo();
      console.error('Error getting Auth0 token:', error);
      return null;
    }
  }
  return null;
};

export const getAccessToken = async () => {
  const auth0Token = await getAuth0Token();
  if (auth0Token) {
    return auth0Token;
  }

  console.error('No Auth0 access token available');
  return null;
};

export const clearTokenInfo = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('expireToken');
  clearAuth0Cache();
};

export const clearAllAuthState = () => {
  auth0TokenGetter = null;
  clearTokenInfo();
  clearAuth0Cookies();
};
